import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
/* eslint-disable jsx-a11y/label-has-associated-control */
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { getDescriptionId, getFeedbackErrorId } from "../../../utils/field";
import { Feedback } from "../Feedback/Feedback";
import * as styles from "./FieldWrapper.styles";
export var FieldWrapper = function FieldWrapper(_ref) {
  var _ref$$completed = _ref.$completed,
    $completed = _ref$$completed === void 0 ? false : _ref$$completed,
    children = _ref.children,
    description = _ref.description,
    error = _ref.error,
    feedback = _ref.feedback,
    fieldId = _ref.fieldId,
    label = _ref.label,
    _ref$labelHidden = _ref.labelHidden,
    labelHidden = _ref$labelHidden === void 0 ? false : _ref$labelHidden;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledLabel, {
    dangerouslySetInnerHTML: {
      __html: label
    },
    htmlFor: fieldId,
    $_css: labelHidden ? styles.labelScreenReaderOnly : styles.label
  }), description && /*#__PURE__*/React.createElement(_StyledP, {
    id: getDescriptionId(fieldId),
    $_css2: styles.description
  }, description), /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-has-error": !!error,
    "data-is-valid": $completed,
    $_css3: styles.wrapper
  }, children, !error && !feedback ? null : /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css4: styles.fieldFeedbackContainer
  }, !error ? /*#__PURE__*/React.createElement(Feedback, {
    iconAlign: "left",
    name: feedback === null || feedback === void 0 ? void 0 : feedback.name,
    value: feedback === null || feedback === void 0 ? void 0 : feedback.value
  }) : /*#__PURE__*/React.createElement(Feedback, {
    error: !!error,
    iconAlign: "left",
    id: getFeedbackErrorId(fieldId),
    name: error,
    value: feedback === null || feedback === void 0 ? void 0 : feedback.value
  }))));
};
var _StyledLabel = _styled("label")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledP = _styled2("p")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = /*#__PURE__*/_styled4("div").withConfig({
  displayName: "FieldWrapper___StyledDiv2",
  componentId: "sc-139t3x7-0"
})(["", ""], function (p) {
  return p.$_css4;
});